import {page} from "./page";
var pageBtn = function(btn){
    var onClick = function (event){
        event.preventDefault();
        var param = JSON.parse(btn.getAttribute('data-param'));
        page(param);
    };

    //
    btn.addEventListener('click', onClick);
}

export {pageBtn};



